import { render, staticRenderFns } from "./formattedFirstAid.vue?vue&type=template&id=dfc85de8"
import script from "./formattedFirstAid.vue?vue&type=script&lang=js"
export * from "./formattedFirstAid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports